var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.06371C14.2386 1.3121 9.76143 1.3121 7 4.06371H6C4.89543 4.06371 4 4.95596 4 6.05661V10.6853C4.31685 10.5913 4.65251 10.5408 5 10.5408H6.13378C6.0487 10.3943 6 10.2241 6 10.0426V8.04973C6 7.4994 6.44772 7.05328 7 7.05328H17C17.5523 7.05328 18 7.4994 18 8.04973V10.0426C18 10.2241 17.9513 10.3943 17.8662 10.5408H19C19.3475 10.5408 19.6831 10.5913 20 10.6853V6.05661C20 4.95596 19.1046 4.06371 18 4.06371H17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.0284C3 12.9278 3.89543 12.0355 5 12.0355H19C20.1046 12.0355 21 12.9278 21 14.0284C21.5523 14.0284 22 14.4745 22 15.0249V19.0107C22 19.561 21.5523 20.0071 21 20.0071V21.0036C21 21.5539 20.5523 22 20 22H19C18.4477 22 18 21.5539 18 21.0036V20.0071H6V21.0036C6 21.5539 5.55228 22 5 22H4C3.44772 22 3 21.5539 3 21.0036V20.0071C2.44772 20.0071 2 19.561 2 19.0107V15.0249C2 14.4745 2.44772 14.0284 3 14.0284Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed1);
export default __webpack_public_path__ + "static/media/bed-1.c42f0a20af1327f9b380b7feb0d53053.svg";
export { ForwardRef as ReactComponent };